import { createAsyncThunk } from '@reduxjs/toolkit';
import { setDefaultTimeZone } from '../../utils';
import { WorkspaceDetailsInterface } from './types';

const setWorkspace = createAsyncThunk(
  'workspaces/setWorkspace',
  async (
    workspace: WorkspaceDetailsInterface
  ): Promise<WorkspaceDetailsInterface> => {
    localStorage.setItem('selectedWorkspaceId', String(workspace.company.id));

    setDefaultTimeZone(workspace.company.timezone);

    return workspace;
  }
);

export default setWorkspace;
